import React, { useContext, useEffect, useState } from "react";

import Divider from '@mui/material/Divider';
import SaveIcon from '@mui/icons-material/Save';
import WarningIcon from '@mui/icons-material/Warning';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Stack, Autocomplete, TextField, LinearProgress, Button, Modal, Container } from '@mui/material';

import HoaPdfViewer from "../pdf-viewer/hoa-pdf-viewer";
import SubHeaderComponent from '../sub-header/hoa-sub-header';
import config from '../../hoa-config';
import dashboardServices from "../../services/hoa-dashboard-api-service";
import { GlobalContext } from "../../context/hoa-global-context";
import datastore from "../../store/hoa-datastore";
import TryagainModal from "../Tryagain-modal/TryagainModal";
import { saveNewLogsInDatastore } from "../../utility/change-log";
import NonAssignableComponent from './hoa-mail-non-assignable-component';
import PropertyUpdateCheckComponent from "./property-update-available-comp";
import useCreateLogs from '../../hooks/useCreateLogs';
import LoadingComponent from "../loading-component/loading-component";
import propertyTaskService from '../../services/hoa-property-task-service';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import EditCancelConfirmationModal from "../../shared-components/edit-cancel-confirmation";

export default function MailAssignDocument(props: any) {
    const { 
        view, 
        setView, 
        tagType,
        toggleModalOpen, 
        selectedValues, 
        updateSelectedValues, 
        assignedPropertyList, 
        setAssignedPropertyList, 
        currentAssignedProperty, 
        setCurrentAssignedProperty, 
        deletedAssignedPropertyList, 
        setDeletedAssignedPropertyList 
    } = props;

    const {mail, updateMailData} = useContext<any>(GlobalContext);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState(selectedValues)
    const [open, setOpen] = useState(false);
    const [url, setUrl] = useState('');
    const [prevMail, setPrevMail] = useState(JSON.parse(JSON.stringify(selectedValues)));
    const [isDuplicate, setIsDuplicate] = useState(false);
    const [suggestivePropertyId, setSuggestivePropertyId] = useState("");
    const [isCancelClicked, setIsCancelClicked] = useState(false);


    useEffect(() => {
        if (state.status !== "Unassigned") return;
		if (!Array.isArray(state.propertySuggestion) || state.propertySuggestion.length === 0)
			return;
		const suggestiveProperty = state?.propertySuggestion[0];
		const isPropertyAlreadyIncluded = selectedValues?.propertyList?.find((property: any) => {
			return property.objectId === suggestiveProperty.objectId;
		});

        console.log(isPropertyAlreadyIncluded);

		if (!isPropertyAlreadyIncluded) {
			setCurrentAssignedProperty({ ...suggestiveProperty });
            setSuggestivePropertyId(suggestiveProperty.objectId)
		}

        return () => {
            setSuggestivePropertyId("")
        }

    }, [])

    const handleClose = () => {
        setOpen(false);
    }

    useEffect(() => {
        setState({...state, propertyList: assignedPropertyList})
    },[assignedPropertyList]);

    useEffect(() => {
        if(selectedValues?.propertyList){
            setAssignedPropertyList(selectedValues.propertyList)
        }
        setPrevMail(selectedValues)
        return() => {
            setAssignedPropertyList([]);
            setDeletedAssignedPropertyList([]);
        }
    },[]);

    const isNonAssignableValueChange = () => {
        return state.mailNonAssignable !== selectedValues.mailNonAssignable
    }

    const onSaveClick = async () => {
        if((state.documentType && currentAssignedProperty) || 
            deletedAssignedPropertyList.length > 0 || isNonAssignableValueChange() || 
            state.propertyUpdateAvailable || !state.propertyUpdateAvailable){
            setOpen(!open);
        }else{
            return;
        }
    };

    const onCancelYesClick = async () => {
        setCurrentAssignedProperty(null);
        setDeletedAssignedPropertyList([]);
        updateSelectedValues(prevMail);
        setView("list");
        setIsCancelClicked(false);
    }

    const onCancelClick = () => {
        setIsCancelClicked(!isCancelClicked);
    }

    const handleChange = (value: any) => {
        setState({...state, documentType: value})
    }

    const removeCurrentAssignedProperty = async() => {
        setCurrentAssignedProperty(null);
    }

    const removePropertyFromPropertyList = (removedProperty: any) => {
        if (removedProperty?.objectId) {
            // remove from propertyList
            
            const copyOfAssignedPropertyList = JSON.parse(JSON.stringify(assignedPropertyList));
            let  indexOfRemovedProperty = -1;
            
            copyOfAssignedPropertyList.forEach((property:any, index: number) => {
                if (property?.objectId === removedProperty.objectId) {
                    indexOfRemovedProperty = index;
                }
            });

            if (indexOfRemovedProperty > -1) {
                copyOfAssignedPropertyList.splice(indexOfRemovedProperty, 1);            
            }

            setAssignedPropertyList(copyOfAssignedPropertyList);

            // add removed item in deletedPropertyList

            setDeletedAssignedPropertyList([...deletedAssignedPropertyList, removedProperty]);
            setIsDuplicate(false);   
        }
    }

    const viewDocument = async (fileUrl: any) => {
        if(!fileUrl) {
            return;
        }
        let path = `hoaMails/${fileUrl?.name}`
        const documentUrl = await dashboardServices.getSignedUrl(path, '', true);
        setUrl(documentUrl.data)
    }

    useEffect(() => {
        viewDocument(selectedValues.attachmentDetails)
    },[selectedValues])

    const renderAssignedPropertyList = () => {
        return assignedPropertyList.map((assignedProperty:any) => {
            return (
                <div className="assigned-property-container">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                        <div>External Id: {assignedProperty?.hoaPropertyDetails?.externalId}</div>
                        <Button style={{ background: "#787878" }} onClick={() => removePropertyFromPropertyList(assignedProperty)}>
                            <DeleteOutline id='icon-componenet' />
                        </Button>
                    </div>
                    <div style={{ color: "#3576E5", fontSize: 16, fontWeight: 400, marginBottom: 34, boxShadow: "inset 0px -1px 0px #E8E8E8" }}>
                        <div style={{ marginBottom: 24 }}>{assignedProperty?.fullAddress}</div>
                        {assignedProperty?.isDeleted &&
                         <div style={{ marginBottom: 24, color:"red" }}>This property is not available</div>
                        }
                    </div>
                </div>
            )
        });
    }

    const isMailSaveButtonDisabled = () => {
        return !(
            state.documentType && (currentAssignedProperty ||
            deletedAssignedPropertyList.length > 0 ||
            isNonAssignableValueChange())
        );
    };

    const duplicateMailIdClicked = (mailId:any) => {
        const {
            objectId
        }  = selectedValues

        let currentUrl = window.location.href;
        if (currentUrl) {
            currentUrl = currentUrl.replace(objectId, mailId);
            window.open(currentUrl);
        }
    }

    return (
		<div className="main-hoa-container" style={{ paddingBottom: 24, border: 0}}>
            <SubHeaderComponent
                view={view}
                loading={loading}
                selectedValues={selectedValues}
                tagType={"Mail"}
                onSaveClick={onSaveClick}
                onCancelClick={onCancelClick}
                style={{ border: "1px solid #e8e8e8" }}
                state={state}
                isMailSaveButtonDisabled={isMailSaveButtonDisabled}
                onCancelYesClick={onCancelYesClick}
            />
            <LoadingComponent loading={loading} />
			<div className="mail-assign-container">
                <div className="mail-assign-left-container">
                    <div className="sub-title-text" style={{marginBottom:"24px"}}>Basic Information</div>
                    <Autocomplete
                        ListboxProps={{ style: { maxHeight: "200px"} }}
                        style={{ width: "80%", height:"62px", boxSizing:"border-box"}}
                        disablePortal
                        value={state.documentType ? state.documentType : ''}
                        options={config.assignMailDocumentTypes}
                        onChange={(e, v) => {
                            handleChange(v)
                        }}
                        renderInput={(params: any) => <TextField variant="standard" required style={{height:"100%"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label="Document Type"/>}
                    />
                    <Stack display={"flex"} flexDirection={'row'} justifyContent={'space-between'} alignItems={'baseline'}>
                        <Stack>
                            {
                                assignedPropertyList.length == 0 ? 
                                <>
                                    <div className="sub-title-text" style={{ marginTop:"24px" }}>Assign to a Property</div>
                                    <div className="helperText" style={{ marginBottom: "10px" }}>Please select the property to assign the document</div>
                                </>
                                :  <div className="sub-title-text" style={{ marginTop:"24px" }}>Assigned Property List</div>
                            }
                            {
                                assignedPropertyList.length == 0 ?
                                <Button 
                                    variant="contained"
                                    color="primary"
                                    disabled={state.status === 'Non-assignable' || state.mailNonAssignable === true}
                                    onClick={()=> toggleModalOpen(true)}
                                >
                                    Assign Property *
                                </Button>
                                :
                                <Button 
                                    variant="contained"
                                    color="primary"
                                    onClick={()=> toggleModalOpen(true)}
                                >
                                    Assign More Property
                                </Button>                        
                            }

                        </Stack>
                        <Stack>
                            <NonAssignableComponent 
                                state={state}
                                setState={setState}
                                isPropertyListChange={currentAssignedProperty || deletedAssignedPropertyList.length > 0}
                            />
                            <PropertyUpdateCheckComponent
                                state={state}
                                setState={setState}
                            />
                        </Stack>
                    </Stack>
                    {
                        currentAssignedProperty ?
                        <>
                            <div className="assigned-property-container">
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                    <div>External Id: {currentAssignedProperty?.hoaPropertyDetails?.externalId}</div>
                                    <Button style={{ background: "#787878" }} onClick={removeCurrentAssignedProperty}>
                                        <DeleteOutline id='icon-componenet' />
                                    </Button>
                                </div>
                                {suggestivePropertyId === currentAssignedProperty?.objectId && <AutoFixHighIcon />}
                                <div style={{ color: "#3576E5", fontSize: 16, fontWeight: 400, marginBottom: 34, boxShadow: "inset 0px -1px 0px #E8E8E8" }}>
                                    <div style={{ marginBottom: 24 }}>{currentAssignedProperty?.fullAddress}</div>
                                </div>
                            </div>
                            <Divider/>
                        </>
                        : <> </>
                    }
                    {
                        renderAssignedPropertyList()
                    }
                </div>
                <div className="mail-assign-right-container">
                    <div className="assigned-mail-property-container" style={{marginTop: '14px'}}>
                        <div className="sub-title-text">Other Information</div>
                        <div className="text-787878-14px">Senders Name: <span className="text-3E3E3E-14px">{state?.sendFrom?.name}</span></div>
                        <div className="text-787878-14px">Senders Address: <span className="text-3E3E3E-14px">{state?.sendFrom?.address}</span></div>
                        <div className="text-787878-14px">Recipients Name: <span className="text-3E3E3E-14px">{state?.sendTo?.name}</span></div>
                        <div className="text-787878-14px">Recipients Address: <span className="text-3E3E3E-14px">{state?.sendTo?.address}</span></div>
                        <div className="text-787878-14px">PCN: <span className="text-3E3E3E-14px">{state?.pcn || 'N/A'}</span></div>
                        <div className="text-787878-14px">SPS Document Type: <span className="text-3E3E3E-14px">{state?.spsDocumentType || 'N/A'}</span></div>
                        {
                            state?.duplicateMailId &&
                            <div className="text-787878-14px">Duplicate Mail ID:
                                <Button
                                    onClick={() => duplicateMailIdClicked(state.duplicateMailId)}
                                    style={{
                                        textTransform: "capitalize",
                                        marginLeft: '15px'
                                    }}
                                    variant="outlined"
                                    startIcon={<OpenInNewIcon />}
                                >
                                    <span className="text-3E3E3E-14px bold">{state.duplicateMailId}</span>
                                </Button>
                            </div>
                        }
                    </div>
                </div>
			</div>
            {
                !url ? <LinearProgress style={{margin:"5px 0px"}}/> :
                <HoaPdfViewer
                    fileUrl={url}
                />
            }
            <SaveComponent 
                isNonAssignableValueChange={isNonAssignableValueChange}
                previousState={prevMail} 
                tagType={tagType}
                mail={mail} 
                updateMailData={updateMailData} 
                open={open} 
                setOpen={setOpen} 
                handleClose={handleClose} 
                state={state} 
                view={view} 
                setView={setView} 
                setLoading={setLoading} 
                currentAssignedProperty={currentAssignedProperty} 
                setCurrentAssignedProperty={setCurrentAssignedProperty}
                deletedAssignedPropertyList={deletedAssignedPropertyList}
                setDeletedAssignedPropertyList={setDeletedAssignedPropertyList}
                isDuplicate={isDuplicate}
                setIsDuplicate={setIsDuplicate}
            />
            <EditCancelConfirmationModal 
                isCancelClicked={isCancelClicked}
                setIsCancelClicked={setIsCancelClicked}
                onCancelYesClick={onCancelYesClick}
            />
		</div>
	);
}

const SaveComponent = ({
    tagType,
    previousState, 
    mail,
    updateMailData, 
    open, 
    setOpen, 
    handleClose, 
    state, 
    view, 
    setView, 
    setLoading, 
    currentAssignedProperty, 
    setCurrentAssignedProperty, 
    deletedAssignedPropertyList, 
    setDeletedAssignedPropertyList,
    isNonAssignableValueChange,
    isDuplicate,
    setIsDuplicate
}: any) => {
    const {pendingSource, updatePendingSource} = useContext<any>(GlobalContext);
    const [showApiErrorModal,setShowApiErrorModal] = useState(false)
    const { createLogsForNonAssignableMail, revertNonAssignableMailLog } = useCreateLogs();
    const currentUser = datastore.ownerInformation.email

    const createLogsPayloadMaker = (propertyId:string, status: string, billableItem?: string) => {
        const type = 'Property';

		// set primaryEvent
		var events:any = [];
		var primaryEvent = "";

		if(type == 'Property') {
			primaryEvent = `${config.changeLongActionsProperty[status]} (${state?.objectId})`;
		}

        events.push(primaryEvent);
        let logMessage={}
		if(events.length > 0) {
			 logMessage = {
				events:events,
				billItem: billableItem ? billableItem : '',
				evidenceLink: '',
				user: datastore.ownerInformation.name,
				prevState:{},
				updatedState:{},
				type:type,
				tagTypeId:propertyId
			}
        }
        return logMessage
    }
    const createMultipleLogs =async(payload:any)=>{
         const result = await dashboardServices.createMultipleLogs(payload);
         saveNewLogsInDatastore(result.data, datastore);
    }

    const propertyAssignToMail = async () => {
        const copyOfState = JSON.parse(JSON.stringify(state));
        copyOfState.lastUpdatedBy = datastore.ownerInformation.email;
        // remove from propertyAssignDates for deleted properties
        if (Array.isArray(deletedAssignedPropertyList) && deletedAssignedPropertyList.length > 0) {
            const deletedAssignedPropertyIds = deletedAssignedPropertyList.map((property:any) => property?.objectId);

            if (Array.isArray(copyOfState.propertyAssignDates) && copyOfState.propertyAssignDates.length > 0) {
                copyOfState.propertyAssignDates = copyOfState.propertyAssignDates.filter((assignDateObj:any) => {
                    return !deletedAssignedPropertyIds.includes(assignDateObj?.propertyId);
                });
            }
            if (copyOfState.propertyUpdateAvailable) {
                await propertyTaskService.deletePropertyTask({
                    propertyList:deletedAssignedPropertyList,
                    mailId:state.objectId,
                    taskSourceType:'mail'
                })
            }
        }

        // add in propertyAssignDates for current assigned property
        if(currentAssignedProperty) {
            copyOfState.propertyList.push(currentAssignedProperty);

            if (!copyOfState.propertyAssignDates || !Array.isArray(copyOfState.propertyAssignDates)) {
                copyOfState.propertyAssignDates = [];
            }
    
            const currentUtcDateTime = new Date().toUTCString();
            copyOfState.propertyAssignDates.push({
                propertyId: currentAssignedProperty.objectId,
                assignDate: currentUtcDateTime
            });

            if (copyOfState.propertyUpdateAvailable) {
                await propertyTaskService.createPropertyTask({propertyId:currentAssignedProperty.objectId, propertyAssignedDate:currentUtcDateTime, mailId:state.objectId, taskSourceType:'mail'})
            }
        }

        const updatedResult = await dashboardServices.propertyAssignToMail(copyOfState);

        if (tagType === 'PendingSource') {
            // find the index of the updated mail in the pendingSource.data array and remove it from pendingSource.data array
            const copyPendingSourceState = JSON.parse(JSON.stringify(pendingSource));
            copyPendingSourceState.data.filter((value: any, index: number) => {
                if(value.objectId === state.objectId){
                    copyPendingSourceState.data.splice(index, 1);
                }
            })
            updatePendingSource(copyPendingSourceState)
        } else {
            let updateIndex = 0;
            mail.data.find((value: any, index: number) => {
                if(value.objectId === state.objectId){
                    updateIndex = index;
                }
            });
    
            mail.data[updateIndex] = updatedResult.data;
            updateMailData({...mail})
        }

        return updatedResult;
    }

    const createOrUpdatePropertyAssignLog = async (apiResponse:any) => {
        const billableItem = "Mail Processing";

        const createLogArgs=[]
        if (currentAssignedProperty) {
            // create new Mail Processing log
            createLogArgs.push(createLogsPayloadMaker(currentAssignedProperty?.objectId, 'assignedToMail', billableItem))

        }

        if (Array.isArray(deletedAssignedPropertyList) && deletedAssignedPropertyList.length > 0) {
            for (let property of deletedAssignedPropertyList) {
                createLogArgs.push(createLogsPayloadMaker(property?.objectId, 'unAssignedToMail', 'Not Billable'))
                
                //update previous log
                await dashboardServices.updateMailOrEmailAssignedLog(property?.objectId, 'mail', apiResponse?.data?.objectId, 0, 'Not Billable');
            }
        }

        await createMultipleLogs(createLogArgs)
    }

    const createMailLog = async (apiResponse:any) => {
        let logsData = {
            action: apiResponse.data?.status,
            updatedBy: datastore.ownerInformation.email,
            mail: apiResponse.data,
            mailId: apiResponse.data?.objectId
        }

        await dashboardServices.createMailLog(logsData);
    }

    const isPropertyListChange = () => {
        return currentAssignedProperty || deletedAssignedPropertyList.length > 0
    }

    const onDuplicateCheck = async () => {
        setLoading(true);
        setShowApiErrorModal(false);
        handleClose();
        if (currentAssignedProperty) {
            const result = await dashboardServices.mailFileNameDuplicationCheck(currentAssignedProperty.objectId, state.pcn);
            if (result.data) {
                setIsDuplicate(result.data);
                setOpen(result.data);
                return;
            }
        }
        onSaveClick();
    }

    const onSaveClick = async () => {
        try{
            setLoading(true);
            setShowApiErrorModal(false);
            handleClose();

            if (previousState.propertyUpdateAvailable != state.propertyUpdateAvailable && state.propertyUpdateAvailable == false) {
                if (Array.isArray(deletedAssignedPropertyList) && deletedAssignedPropertyList.length > 0) {
                    await propertyTaskService.deletePropertyTask({
                        propertyList: [...deletedAssignedPropertyList, ...state.propertyList],
                        mailId:state.objectId,
                        taskSourceType:'mail'
                    })
                } else {
                    await propertyTaskService.deletePropertyTask({
                        propertyList:state.propertyList,
                        mailId:state.objectId,
                        taskSourceType:'mail'
                    })
                }
            }

            if (previousState.propertyUpdateAvailable != state.propertyUpdateAvailable) {
                const updatedResult = await dashboardServices.propertyUpdateAvailable({
                    objectId: state.objectId,
                    propertyUpdateAvailable: state.propertyUpdateAvailable
                });
                let updateIndex = 0;
                mail.data.find((value: any, index: number) => {
                    if(value.objectId === state.objectId){
                        updateIndex = index;
                    }
                });
        
                mail.data[updateIndex] = updatedResult.data;
                updateMailData({...mail})
            }

            if(isPropertyListChange()) {
                console.log("Assigned Property list")
                const res = await propertyAssignToMail();
                await createMailLog(res);
                await createOrUpdatePropertyAssignLog(res);
            }
            else if(isNonAssignableValueChange()) {
                if(state.status === 'Unassigned' && state.mailNonAssignable === true) {
                    console.log("Non Assignable 1")
                    const result = await dashboardServices.updateMailToNonAssignable(state.objectId, state.documentType, currentUser);
                    await createLogsForNonAssignableMail(state.objectId, state.organization);

                    const selectedIndex = mail.data.findIndex((value: any, index: number) => value.objectId === state.objectId);
                    mail.data[selectedIndex] = result.data;
                    updateMailData({...mail})

                } else if(state.status === 'Non-assignable' && state.mailNonAssignable === false) {
                    console.log("Non Assignable 2")
                    const result = await dashboardServices.updateMailToNonAssignableUnChecked(state.objectId, state.documentType, currentUser);
                    await revertNonAssignableMailLog(state.objectId)

                    const selectedIndex = mail.data.findIndex((value: any, index: number) => value.objectId === state.objectId);
                    mail.data[selectedIndex] = result.data;
                    updateMailData({...mail})
                }
            }
            
            setCurrentAssignedProperty(null);
            setLoading(false);
            setView('list');
        }
        catch(error){
            setLoading(false);
            setShowApiErrorModal(true);
        }
    }

    return(
    <>
        <TryagainModal
            open={showApiErrorModal}
            errorMessage="Save failed. Please try again."
            onClose={()=>setShowApiErrorModal(false)}
            onTryAgain={onSaveClick}
        />
         <Modal open={open}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
			>
				<div className="modal-wrapper-doc">
                    {
                        isDuplicate ?
                        <div>
                            <Stack 
                                style={{ 
                                    alignItems: "center",
                                    padding: '12px 24px',
                                    gap: '12px',	
                                }}
                                direction={"row"}
                                spacing={1}
                                justifyContent="flex-between">
                                <WarningIcon 
                                    style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
                                <div>
                                    <h2 style={{color: '#3E3E3E'}}>Duplicate Document Name</h2>
                                    <p style={{color: '#787878'}}>Duplicate document name detected in the mail attachment section of this property.</p>
                                </div>
                            </Stack>
                            <Stack
                                style={{ marginTop: "24px" }}
                                direction={"row"}
                                spacing={1}
                                justifyContent="flex-end"
                            >
                                <Button onClick={onSaveClick} variant="contained">
                                    Continue
                                </Button>
                            </Stack>
                        </div>
                        :
                        <div>
                            <Stack 
                                style={{ 
                                    alignItems: "center",
                                    padding: '12px 24px',
                                    gap: '12px',	
                                }}
                                direction={"row"}
                                spacing={1}
                                justifyContent="flex-between">
                                <SaveIcon 
                                    style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
                                <div>
                                    <h2 style={{color: '#3E3E3E'}}>Are you sure you want to save?</h2>
                                    <p style={{color: '#787878'}}>Save changes will charge the client, Do you want to proceed?</p>
                                </div>
                            </Stack>
                            
                            <Stack
                                style={{ marginTop: "24px" }}
                                direction={"row"}
                                spacing={1}
                                justifyContent="flex-end"
                            >
                                <Button onClick={() => handleClose()} variant="outlined">
                                    No
                                </Button>
                                <Button onClick={onDuplicateCheck} variant="contained">
                                    Yes
                                </Button>
                            </Stack>
                        </div>
                    }
				</div>
			</Container>
		</Modal>
    </>
 
    )
}